export default __webpack_public_path__ + "static/media/existing.ba49fd60.png";